module.exports = "https://health.dajiuxing.com.cn/img/assets/rightsDetails/Daoan/BottomBackground.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FrightsDetails%2FDaoan%2FBottomBackground.png
// module id = +IF0
// module chunks = 93